import React from "react";
import { Box, Stack } from "@mui/material";
import BookingCard from "./BookingCard";

const BookingList = ({ bookings }) => {
  if (!bookings?.length) {
    return null;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={2} component="ul" sx={{ listStyle: "none", m: 0, p: 0 }}>
        {bookings.map((booking) => (
          <Box component="li" key={booking.id}>
            <BookingCard booking={booking} />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default BookingList;
